import styled from "styled-components";
import { FlexContainer } from "styled/Box";

export const UploadContainer = styled(FlexContainer)`
  min-height: 250px;
  width: 100%;
`;
